import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorNoteNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface INoteModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const INoteFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useNoteHookNae(id: number) : INoteModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorNoteNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Note.schema,
        fields: INoteFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
